export const CURRENCIES = {
    USD: 'USD',
    EUR: 'EUR',
    RUB: 'RUB',
}
